import React, { Component } from 'react';

import Loading from '../../common/loading';
import { Page, PageHeader, Card, SearchInput, DataList, TextButton, FlushButtons, matchSearch } from '../../common/ui';
import ModalGroup from '../../common/modal/modalGroup';
import { randomString } from '../../common/actions/randomString';
import { controlRole } from '../../common/actions/controlRole';
import Date from '../../common/date';
import { isEmpty, withNavigate } from '../../utility';

class partners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            isLoading: false,
            loadingForRole: true,
            randomString: randomString(),

            hasClickNewGroup: false,
            hasClickUpdateGroup: false,
            hasClickDeleteGroup: false,

            groupTemp: {},

            // testo di ricerca nella lista
            search: ''
        }
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare i gruppi, viene rispedito alla home
        if (!isEmpty(this.props.role.user)) {
            if (!controlRole(this.props.role.user, "api/User/Group", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare i gruppi!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.props.getGroupList();
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare i gruppi, viene rispedito alla home
        if (!isEmpty(this.props.role.user)) {
            if (!controlRole(this.props.role.user, "api/User/Group", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare i gruppi!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.props.getGroupList();
                }
            }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
    }

    closeModal = () => {
        this.setState({
            modal: false,
            hasClickNewGroup: false,
            hasClickUpdateGroup: false,
            hasClickDeleteGroup: false,
            groupTemp: {}
        })
    }

    /**
     * Se clicco nuovo gruppo, attivo la modale con le relative informazioni.
     */
    hasClickNewGroup = () => {
        this.setState({
            hasClickNewGroup: true
        });
        setTimeout(() => {
            this.toggleModal();
        }, 200);
    }

    /**
     * Se clicco modifica gruppo, attivo la modale con le relative informazioni.
     */
    hasClickUpdateGroup = (el) => {
        this.setState({
            hasClickUpdateGroup: true,
            groupTemp: el
        });
        setTimeout(() => {
            this.toggleModal();
        }, 200);
    }

    /**
     * Se clicco elimina gruppo, attivo la modale con le relative informazioni.
     */
    hasClickDeleteGroup = (el) => {
        this.setState({
            hasClickDeleteGroup: true,
            groupTemp: el
        });
        setTimeout(() => {
            this.toggleModal();
        }, 200);
    }

    /**
     * Controllo se è un nuovo gruppo, da modificare o da cancellare e 
     * chiama il BE, inviando i dati che occorrono.
     * 
     * @param {*} data 
     */
    confirmSend = (data) => {
        if (this.state.hasClickNewGroup) this.props.addGroup(data);
        if (this.state.hasClickUpdateGroup) this.props.updateGroup(data);
        if (this.state.hasClickDeleteGroup) this.props.deleteGroup(data);
        this.closeModal();
    }

    render() {
        const { hasClickDeleteGroup, hasClickNewGroup, hasClickUpdateGroup, search } = this.state;
        const { group, role, errorNotify } = this.props;

        const canEdit = controlRole(role.user, "api/User/Group/Update", "PUT");
        const canDelete = controlRole(role.user, "api/User/Group", "DELETE");
        const groups = (group.listGroup || []).filter(el => matchSearch(search, el.name, el.description));

        return (
            <Page>
                <PageHeader
                    title="Gruppi"
                    subtitle={`${(group.listGroup || []).length} gruppi`}
                    actions={
                        <>
                            <FlushButtons
                                canFlush={controlRole(role.preferences, "api/Preferences/flush", "POST")}
                                canFlushConfig={controlRole(role.configFlush, "api/Config", "POST")}
                                onFlush={this.props.flush}
                                onFlushConfig={this.props.flushConfig}
                            />
                            {
                                controlRole(role.preferences, "api/Preferences", "PUT") &&
                                <button type="button" className="btn btn-sm btn-success" onClick={this.hasClickNewGroup}>
                                    <i className="fas fa-plus" aria-hidden="true" /> Nuovo gruppo
                                </button>
                            }
                        </>
                    }
                />

                {
                    (group.isLoading || this.state.isLoading || this.state.loadingForRole) ? <Loading /> :
                        <Card>
                            <div className="uiToolbar">
                                <SearchInput value={search} onChange={value => this.setState({ search: value })} placeholder="Cerca per nome o descrizione" />
                                {search && <span className="uiCount">{groups.length} risultati</span>}
                            </div>

                            <DataList
                                columns={[
                                    { key: 'name', label: 'Nome', width: 'minmax(120px, 1fr)' },
                                    { key: 'description', label: 'Descrizione', width: 'minmax(0, 2fr)', render: el => el.description || <span className="uiMuted">—</span> },
                                    { key: 'createdAt', label: 'Creato il', width: '170px', render: el => <Date format="L" date={el.createdAt} onlyLabel /> },
                                ]}
                                rows={groups}
                                rowKey={el => el.name}
                                empty={search ? 'Nessun gruppo trovato' : 'Nessun gruppo'}
                                actions={
                                    (canEdit || canDelete) ?
                                        el => (
                                            <>
                                                {canEdit && <TextButton icon="far fa-edit" onClick={() => { this.hasClickUpdateGroup(el) }}>Modifica</TextButton>}
                                                {canDelete && <TextButton icon="far fa-trash-alt" variant="danger" onClick={() => { this.hasClickDeleteGroup(el) }}>Elimina</TextButton>}
                                            </>
                                        )
                                        : undefined
                                }
                            />
                        </Card>
                }

                {
                    (this.state.hasClickNewGroup || this.state.hasClickUpdateGroup || this.state.hasClickDeleteGroup) &&
                    <ModalGroup
                        titleModal={
                            hasClickNewGroup ? "Nuovo Gruppo" :
                                hasClickUpdateGroup ? "Modifica Gruppo" :
                                    hasClickDeleteGroup ? "Elimina Gruppo" : ""
                        }

                        toggle={this.closeModal}
                        stateModal={this.state.modal}

                        errorNotify={errorNotify}
                        isNewGroup={hasClickNewGroup}
                        isUpdateGroup={hasClickUpdateGroup}
                        isDeleteGroup={hasClickDeleteGroup}

                        confirmSend={this.confirmSend}

                        dataGroup={this.state.groupTemp}

                        key={this.state.randomString}
                    />
                }
            </Page>
        )
    }
}

export default withNavigate(partners);